module.exports = __webpack_public_path__ + "static/flag-eu-erdf-eng-758bc54260ca55a2cb1cba0b2a1297e0.jpg";